/**
 * API client for the per-tenant JWT verifier registry admin endpoints
 * (Phase A - doc 21 §2.1).
 */

import { apiFetch } from './api';

export interface JwtVerifier {
  id: string;
  tenantId: string;
  kind: 'jwks' | 'oidc' | 'saml';
  label: string;
  issuer: string;
  config: {
    jwksUrl?: string;
    audience?: string;
    allowedAlgs?: string[];
    clockToleranceSeconds?: number;
  };
  enabled: boolean;
  isSystem: boolean;
  createdAt: string;
  updatedAt: string;
}

export async function listJwtVerifiers(): Promise<JwtVerifier[]> {
  const res = await apiFetch<{ verifiers: JwtVerifier[] }>('/v1/admin/jwt-verifiers');
  return res.verifiers;
}

export interface CreateJwtVerifierInput {
  kind: 'jwks';
  label: string;
  issuer: string;
  config: {
    jwksUrl: string;
    audience: string;
    allowedAlgs?: string[];
    clockToleranceSeconds?: number;
  };
}

export async function createJwtVerifier(input: CreateJwtVerifierInput): Promise<JwtVerifier> {
  return apiFetch<JwtVerifier>('/v1/admin/jwt-verifiers', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export async function setVerifierEnabled(id: string, enabled: boolean): Promise<JwtVerifier> {
  return apiFetch<JwtVerifier>(`/v1/admin/jwt-verifiers/${id}`, {
    method: 'PATCH',
    body: JSON.stringify({ enabled }),
  });
}

export async function deleteJwtVerifier(id: string): Promise<void> {
  await apiFetch<void>(`/v1/admin/jwt-verifiers/${id}`, { method: 'DELETE' });
}
